module.exports = __webpack_public_path__ + "static/media/car.7824021c.png";